const enabledBrands = new Set([
  "audi",
  "bmw",
  "cupra",
  "dacia",
  "ford",
  "kia",
  "mercedes",
  "mg",
  "nissan",
  "polestar",
  "porsche",
  "renault",
  "rullavidare",
  "seat",
  "skoda",
  "volkswagen",
  "volkswagentransportbilar",
  "volvia",
  "volviaforetag",
]);

export function shouldShowStickyPriceButton(brand?: string): boolean {
  return brand ? enabledBrands.has(brand.toLowerCase()) : false;
}